import { Inject, Injectable } from '@angular/core';
import { AppConfig, LanguageCode, LanguageCodeUpper, Replace } from '@digilize/shared/definitions/src';
import { Multilingual } from '@digilize/shared/definitions/src/lib/interfaces/Multilingual';
import { APP_CONFIG } from '@digilize/shared/utils/tokens/src';
import { TranslocoService } from '@ngneat/transloco';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class I18nService {
  localeEvent = new Subject<LanguageCode>();
  langToChooseFrom$ = new BehaviorSubject(this.appConfig.language.languages);
  constructor(private translocoService: TranslocoService, @Inject(APP_CONFIG) private appConfig: AppConfig) {}

  init() {
    this.setLang(this.tryGetLangFromStorage());
  }

  // initLazyLoadedModule(translateRef: TranslateService) {
  //   /* fixes problem described here https://github.com/ngx-translate/core/issues/1193*/
  //   /* lib has no emitter specific emitter for translation loaded, so we wait for langChange to be sure new translations have been loaded -  */
  //   translateRef.onLangChange.pipe(take(1)).subscribe((el) => {
  //     this.isServiceInitialized || this.init();
  //     this.resetTranslations(translateRef);
  //     translateRef.setDefaultLang(this.tryGetLangFromStorage());
  //   });

  //   setTimeout(() => {
  //     this.isServiceInitialized || this.init();
  //     this.resetTranslations(translateRef);
  //   }, 500);
  //   /* this covers language change case*/
  //   this.localeEvent.subscribe((locale) => translateRef.use(locale));
  // }

  // private resetTranslations(translateRef: TranslateService) {
  //   const currentLang = translateRef.currentLang;
  //   translateRef.currentLang = '';
  //   translateRef.use(currentLang);
  // }

  setLangAndSave(lang: LanguageCode | LanguageCodeUpper) {
    const langLower = lang.toLowerCase() as LanguageCode;
    this.setLang(langLower);
    localStorage.setItem('lang', langLower);
  }

  setLang(lang: LanguageCode) {
    this.translocoService.setDefaultLang(lang);
    this.translocoService.setActiveLang(lang);
    this.localeEvent.next(lang);
  }

  getTextFromMultilingual(multi: Multilingual, replace?: Replace): string {
    if (!multi) return '';
    const activeLang = this.translocoService.getActiveLang();
    const text = multi[this.translocoService.getActiveLang() as keyof Multilingual];
    return replace ? text.replace(replace.searchValue, replace.replaceValue) : text;
  }

  tryGetLangFromStorage(): LanguageCode {
    const langListLower = this.appConfig.language.languages.map((lang) => lang.code.toLowerCase());
    const browserLanguage = this.getFirstBrowserLanguage();
    if (localStorage.getItem('lang')) {
      const langCodeFromStorage = localStorage.getItem('lang') as LanguageCode;
      /* we are checking if lang from localstorage exists in app.config (other localhost projects might have wider variety of langs)  */
      return this.appConfig.language.languages.find((lang) => lang.code === langCodeFromStorage)
        ? langCodeFromStorage
        : this.appConfig.language.defaultLanguage;
    } else {
      return langListLower.includes(browserLanguage)
        ? browserLanguage
        : this.appConfig.language.defaultLanguage.toLowerCase();
    }
  }
  private getFirstBrowserLanguage() {
    let nav = window.navigator,
      browserLanguagePropertyKeys = ['language', 'browserLanguage', 'systemLanguage', 'userLanguage'],
      i,
      language;

    // support for HTML 5.1 "navigator.languages"
    if (Array.isArray(nav.languages)) {
      for (i = 0; i < nav.languages.length; i++) {
        language = nav.languages[i];
        if (language && language.length) {
          return language.split('-')[0];
        }
      }
    }

    // support for other well known properties in browsers
    for (i = 0; i < browserLanguagePropertyKeys.length; i++) {
      language = nav[browserLanguagePropertyKeys[i]];
      if (language && language.length) {
        return language.split('-')[0];
      }
    }

    return null;
  }

  updateLangToChooseFrom(toChooseFrom: LanguageCode[] | LanguageCodeUpper[]) {
    /* toChooseFrom languages must exist in appConfig providers*/
    const newLangs = this.appConfig.language.languages.filter((lang) => {
      return toChooseFrom.map((from) => from.toLowerCase() as LanguageCode).find((from) => from === lang.code);
    });
    this.langToChooseFrom$.next(newLangs);
  }
}
